// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__a1v7H","badge__point":"style_badge__point__ElWOl","badge__text":"style_badge__text__tAvoU"};